<template>
  <div id="login-page">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6">
        <v-card class="elevation-12">
          <v-toolbar align="center" color="primary" dark flat>
            <v-toolbar-title>Connexion à la plateforme Heliocity</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field :error="loginError !== false" v-model="form.email" label="Adresse email" name="email" prepend-icon="person" type="email" />
              <v-text-field :error="loginError !== false" v-model="form.password" id="password" label="Mot de passe" name="password" prepend-icon="lock" type="password" />
            </v-form>
            <p color="error" v-if="loginError !== false">{{ loginError }}</p>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-spacer />
            <v-btn class="mb-5" @click="tryLogin({email: form.email, password: form.password})" color="primary">
              Connexion
            </v-btn>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// import {authActions} from "../../store/modules/Auth/actions";

export default {
  name: "Login",
  data() {
    return {
      form: {
        email: "",
        password: ""
      }
    };
  },
  computed: {
    ...mapGetters(["loginError"])
  },
  methods: {
    ...mapActions(["login"]),
    tryLogin() {
      this.login({
        email: this.form.email,
        password: this.form.password
      });
    }
  }
};
</script>

<style lang="scss">
</style>
